import { render } from "./ParCreate.vue?vue&type=template&id=1d4ba66c"
import script from "./ParCreate.vue?vue&type=script&lang=js"
export * from "./ParCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__